import type { UserManager } from "oidc-client-ts";
import { createContext } from "react";

interface UserManagersContextType {
  evbasicUserManager: UserManager | undefined;
  evcoreUserManager: UserManager | undefined;
  setSilentRefreshInProgress?: (inProgress: boolean) => void;
}

export const UserManagersContext = createContext<UserManagersContextType | undefined>(undefined);
